<div class="buttons">
  <div [ngClass]="'buttons__content--' + align">
    <ng-content></ng-content>
  </div>
</div>
